import { render, staticRenderFns } from "./index.vue?vue&type=template&id=565b7752"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565b7752')) {
      api.createRecord('565b7752', component.options)
    } else {
      api.reload('565b7752', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=565b7752", function () {
      api.rerender('565b7752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/element/dialog/index.vue"
export default component.exports